import * as Yup from "yup";
import { editServiceService } from "../../services/servicesServices.js";
import Alert from "../../utils/Alert.js";

export const initialValues = {
    status: "",
    unit_price: "",
    admin_description: "",
    expire_time: "",
    preparation_time: "",
    phases: []
};

export const initialTouched = {
    status: true,
    unit_price: true,
    admin_description: true,
    expire_time: true,
    preparation_time: true
};

export const onSubmit = async (values, actions, editingService, setForceRequest, navigate) => {
    console.log("this is the value", values)
    try {
        const response = await editServiceService(editingService.code, values);
        if(response.status === 200) {
            setForceRequest(prevValue => prevValue + 1);
            Alert("انجام عملیات", "سرویس با موفقیت ویرایش شد", "success");
            return navigate(-1);
        }
    } catch (error) {
        
    }
}

export const validationSchema = Yup.object().shape({
    status: Yup.string().required("لطفاً یک وضعیت برای سرویس انتخاب کنید"),
    unit_price: Yup.number().typeError("لطفاً فقط عدد وارد کنید")
    .required("لطفاً قیمت سرویس را وارد کنید")
    .min(1, "قیمت سرویس نمیتواند 0 یا منفی باشد"),
    admin_description: Yup.string().when("status", {
        is: "r",
        then: (schema) => schema.required("لطفاً علت رد کردن سرویس را بیان کنید")
    }),
    expire_time: Yup.number().required("لطفاً مدت انقضای سرویس را مشخص کنید"),
    preparation_time: Yup.number().required("لطفاً مدت آماده سازی سرویس را مشخص کنید")
    .min(1, "مدت آماده سازی سرویس نمی‌تواند 0 یا منفی باشد"),
    phases: Yup.array().of(  
        Yup.object().shape({  
            title: Yup.string().required("عنوان فاز الزامی است").max(100, "عنوان نمی‌تواند بیش از ۱۰۰ کاراکتر باشد"),  
            price: Yup.number().typeError("لطفاً فقط عدد وارد کنید").required("مبلغ فاز الزامی است").min(1, "مبلغ فاز نمی‌تواند 0 یا منفی باشد"),  
        })  
    )
});